import { Label } from ".";
import { classNames } from "../../utils/helpers";

export default function DateInput({
  label,
  subLabel,
  name,
  placeholder = "",
  required = false,
  value,
  onChange,
  min,
  max,
}) {
  const formattedValue = value ? new Date(value).toISOString().split("T")[0] : "";

  return (
    <>
      {/* Label/required asterisk */}
      {label && <Label label={label} required={required} />}
      <div className={classNames("flex relative", label ? "mt-1" : "")}>
        {/* Input */}
        <input
          type="date"
          name={name}
          className="p-2 rounded-md shadow-md focus:outline-none block w-full text-sm border-gray-300 placeholder-gray-300"
          placeholder={placeholder}
          value={formattedValue}
          onChange={onChange}
          readOnly={!onChange}
          min={min}
          max={max}
        />
      </div>
      {/* Sublabel */}
      {subLabel && (
        <div className="mt-1 text-gray-400 text-xs text-right">{subLabel}</div>
      )}
    </>
  );
}
